import React from "react";
import Toast from "cogo-toast";
import {apiDeleteTariff} from "./Actions";
import {useSelector} from "react-redux";
import ETable, {DeleteIconBtn, EditIconBtn, YesNoBadge} from "../components/Table";

const TariffTable = ({data, setData}) => {
    const user = useSelector((state) => state.user);

    const deleteItem = (id) => {
        apiDeleteTariff(user.activeAreal.id, id, () => {
            setData(prev => prev.filter(v => v.id !== id));
            Toast.success("Tarif byl odstraněn");
        }, (error) => {
            let msg = "Nepodařilo se odstranit tarif.\n";
            if (error.data === "TARIFF_NOT_FOUND") msg += "Nebyl nalezen.";
            else msg += "Neznámá chyba";
            Toast.error(msg);
        });
    };

    const columns = [
        {header: "ID",                      key: "id"},
        {header: "Název",                   key: "name"},
        {header: "Musí nejdříve vstoupit",  render: row => <YesNoBadge value={row.reverse === 0}/>},
        {header: "Prochází denně",          render: row => <YesNoBadge value={row.daily === 1}/>},
        {header: "Možnosti", render: row => (
            <div style={{display: "flex", gap: "6px"}}>
                <EditIconBtn to={"/tariff/detail/" + row.id}/>
                <DeleteIconBtn onClick={() => deleteItem(row.id)}/>
            </div>
        )},
    ];

    return <ETable columns={columns} data={data}/>;
};

export default TariffTable;
